import branchComponent from './branch.component';
import BranchCreate from './create'
import BranchEdit from './edit'
import BranchAll from './all'
import windowComponent from './common/window/window.component';

let branchModule = angular.module('branch', [
    BranchCreate,
    BranchEdit,
    BranchAll
  ])

  .component('branch', branchComponent)
  .component('window', windowComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('branch.edit', {
        url: '/edit/:id',
        component: 'branchedit',
        data: {
          requireACL: 'setting-branch.edit'
        }
      })

      .state('branch.create', {
        url: '/create',
        component: 'branchcreate',
        data: {
          requireACL: 'setting-branch.create'
        }
      })

      .state('branch.all', {
        url: '/all/:page',
        component: 'branchall',
        data: {
          requireACL: 'setting-branch.view'
        }        
      })
  })

  .name;

export default branchModule;


// WEBPACK FOOTER //
// ./client/app/components/branch/index.js